/*
 * File: /src/services/connectorService.js
 * Created Date: Tuesday December 7th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Tuesday, 7th December 2021 4:52:20 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */

import { authedAxios } from 'src/shared/axiosWrapper';
import { getConnectorPath } from 'src/shared/axiosBasePath';
import { AD_BASE_CONNECTOR_PATH } from 'src/constants';

export default {
  fetchByCompanyId() {
    return authedAxios.get(AD_BASE_CONNECTOR_PATH);
  },

  // The API updates connectors with POST, there is no PUT route
  updateConnector(id, payload) {
    return authedAxios.post(AD_BASE_CONNECTOR_PATH + id, payload);
  },

  createConnector(payload) {
    return authedAxios.post(AD_BASE_CONNECTOR_PATH, payload);
  },

  // Both syncs enqueue a background job rather than run inline
  syncUnits(id) {
    return authedAxios.post(AD_BASE_CONNECTOR_PATH + id + '/sync-units');
  },

  syncOwners(id) {
    return authedAxios.post(AD_BASE_CONNECTOR_PATH + id + '/sync-owners');
  },

  getRealtimeBooking(connectorId, contactId, bookingCode) {
    // FQDN will override the pre-stored path
    return authedAxios.get(
      getConnectorPath() + '/connectors/' + connectorId + '/' + bookingCode,
      {
        params: {
          contact_id: contactId,
        },
      }
    );
  },
};
